import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { JWTFetchError, UnloggedError } from "./AuthErrors.js";
import { buildUrl } from "./utils.js"; // Types
import { AUTH_TYPE, QUERY_PARAMS_TYPE } from "./types.js";
function WithPartnerLogin(Base) {
  return class WithPartnerLoginAuth extends Base {
    loginAsPartner(token) {
      var _this = this;
      return _asyncToGenerator(function* () {
        const shouldUseCookie = !token;
        const fetchUrl = buildUrl({
          host: _this.host,
          authType: AUTH_TYPE.PARTNER,
          inputType: shouldUseCookie ? QUERY_PARAMS_TYPE.COOKIE : QUERY_PARAMS_TYPE.PAYLOAD,
          tokenOutputType: _this.tokenOutputType,
          refreshTokenOutputType: _this.refreshTokenOutputType
        });
        const response = yield _this.fetch.call(null, fetchUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          credentials: 'include',
          body: shouldUseCookie ? undefined : JSON.stringify({
            partner_access_token: token
          })
        }).catch(() => {
          throw new JWTFetchError('Could not fetch Partner JWT Token');
        });
        if (!response.ok) {
          throw new UnloggedError(`Could not log in as Partner. Got error ${response.status}`);
        }
        if (_this.fetchShouldHaveReponse) {
          var _this$refreshTokenCac, _this$tokenCache;
          const {
            jwt,
            refresh_token
          } = yield response.json().catch(() => {
            throw new JWTFetchError('Response does not contain a valid JWT Token');
          });
          (_this$refreshTokenCac = _this.refreshTokenCache) == null || _this$refreshTokenCac.set(refresh_token);
          (_this$tokenCache = _this.tokenCache) == null || _this$tokenCache.set(jwt);
          return jwt;
        }
        return null;
      })();
    }
  };
}
export default WithPartnerLogin;
//# sourceMappingURL=WithPartnerLogin.js.map